<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Reporte Atenciones</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Atención_01_Px</div>
        </b-col>
      </b-row>



      <div class="mt-2 col-md-12"></div>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(generar)">
          <b-row>
            <b-col>
              <b-row>
                <b-col cols="4">
                  <validation-provider name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha de inicio:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha inicio"
                                         :max="new Date()"
                                         @input="fechaMaxima($event)"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>

                <b-col cols="4">
                  <validation-provider name="fcFinVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha de fin:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha fin"
                                         v-model="filtro.fechaFin"
                                         :max="filtro.fechaInicio.addDays(diasMaximoMes) > new Date() ? new Date(): filtro.fechaInicio.addDays(diasMaximoMes)"
                                         :min="filtro.fechaInicio"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>

              </b-row>
              <b-row>
                <b-col cols="6">
                     <validation-provider name="clinica" :rules="{ required: true }" v-slot="validationContext">
                  <b-form-group align="left">
                    <label for="cuenta">Planes/Convenios <validacion/></label>
                    <v-select  name="cuenta" placeholder="Seleccione un Plan o Convenio"
                               label="nombre"
                               multiple
                               :reduce="(variable) => variable.idPlan"
                               :options="cuentas"
                               v-model="filtro.idPlan"
                    ></v-select>

                    <b-form-checkbox
                        id="checkbox-1"
                        name="checkbox-1"
                        @change="todos($event)">
                      Todos los planes/convenios
                    </b-form-checkbox>
                  </b-form-group>
                   <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>
                 <b-col cols="4">
                  <validation-provider name="clinica" :rules="{ required: true }" v-slot="validationContext">
                    <label>Clínica:<validacion/></label>
                    <b-container>
                      <b-row style="width: 100%">
                        <b-col cols="11">
                          <v-select style="width: 100%" :clearable="false" :options="listaClinicas"
                                    v-model="filtro.clinica"
                                    :reduce="(variable) => variable.idClinica"
                                    label="nombreClinica" placeholder="Selecciona una clínica" multiple>
                            <span slot="no-options">No hay clínicas disponibles</span>
                          </v-select>
                          <b-form-checkbox
                        id="checkbox-2"
                        v-model="todas"
                        name="checkbox-2"
                        @change="seleccionarTodasClinicas($event)">
                      Todas las clinicas
                    </b-form-checkbox>
                        </b-col>
                      </b-row>
                    </b-container>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>
              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col></b-col>
                <b-col class="text-right">
                  <b-button
                      variant="outline-primary"
                      :disabled="loader"
                      @click="obtenerDatos()"
                  >
                    <span v-if="!loader">Buscar</span>
                    <span v-else>
                  <b-spinner small></b-spinner>
                  Buscando...
                </span>
                  </b-button>
                </b-col>

              </b-row>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>

      <b-col cols="12">
        <download-excel
            v-if="datosTabla.length > 0 && $localStorageService.can('BT_01_excel_Rep_Aten_px')"
            class="btn btn-primary"
            :data="datosTabla"
            :fields="fieldsExcel"
            worksheet="ReporteAtenciones"
            name="reporte de atenciones.xls"
        >
          Generar Excel
          <em class="fa fa-file-excel-o"></em>
        </download-excel>
      </b-col>
      <div class="mt-2 col-md-12"></div>

      <b-row>
        <b-col cols="12">
          <b-table
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="$registrosPorPaginaTabla"
              :current-page="paginaActual"
              responsive
              class="parrafos">
            <template v-slot:cell(ingresoSinDescuento)="row">
              {{ row.item.ingresoSinDescuento | monedaEntero }}
            </template>
            <template v-slot:cell(ingresoConDescuento)="row">
              {{ row.item.ingresoSinDescuento | monedaEntero }}
            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla!==undefined && datosTabla.length === 0" variant="warning" show>No hay datos
            </b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="tabla"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>

import Header from "../../../components/Header";

export default {
  components: {
    Header
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loader: false,
      datosTabla: [],
      fields: [],
      paginaActual: 0,

      filtro: {
        idPlan:[],
        fechaInicio: new Date(),
        fechaFin: null,
         clinica: null
      },
      fieldsExcel:{
      "Subtipo de Paciente":"subtipoPaciente",
      "ID Paciente":"idPaciente",
      "Nombre Paciente":"paciente" ,
      "Fecha Nacimiento":"fechaDeNacimiento",
      "Sexo":"sexo",  
      "Clínica":"clinica", 
      "Estado":"estado",  
       "Cuenta":"cuenta",
      "Plan/Convenio":"planConvenio",  
      "Póliza":"numeroPoliza", 
      "Inicio Vigencia de Poliza":"inicioVigPoliza",  
      "Fin Vigencia de Póliza":"finVigPoliza",  
      "Especialidad":"especialidadOrigen",  
      "Tratamiento":"tratamiento",
      "Ingreso sin Descuento":"ingresoSinDescuento",  
      "Ingreso con Descuento":"ingresoConDescuento", 
      "Traspaso":"traspaso", 
      "sessNum":"noSesion",  
      "sessFrom":"noMaxSesiones", 
      "diente":"diente"
      },
      cuentas:[],
      clinicas: [],
      listaClinicas: [],
      hoy: new Date(),
      diasMaximoMes: null
    }
  },
  mounted() {
    this.fields = [
      {key: "subtipoPaciente", label: "Subtipo de Paciente", sortable: true},
      {key: "idPaciente", label: "ID Paciente", sortable: true},
      {key: "paciente", label: "Nombre Paciente", sortable: true},
      {key: "fechaDeNacimiento", label: "Fecha Nacimiento", sortable: true},
      {key: "sexo", label: "Sexo", sortable: true},
      {key: "clinica", label: "Clínica", sortable: true},
      {key: "estado", label: "Estado", sortable: true},
      {key: "cuenta", label: "Cuenta", sortable: true},
      {key: "planConvenio", label: "Plan/Convenio", sortable: true},
      {key: "numeroPoliza", label: "Póliza", sortable: true},
      {key: "inicioVigPoliza", label: "Inicio Vigencia de Poliza", sortable: true},
      {key: "finVigPoliza", label: "Fin Vigencia de Póliza", sortable: true},
      {key: "especialidadOrigen", label: "Especialidad", sortable: true},
      {key: "tratamiento", label: "Tratamiento", sortable: true},
      {key: "ingresoSinDescuento", label: "Ingreso sin Descuento", sortable: true},
      {key: "ingresoConDescuento", label: "Ingreso con Descuento", sortable: true},
      {key: "traspaso", label: "Traspaso", sortable: true},
      {key: "noSesion", label: "sessNum", sortable: true},
      {key: "noMaxSesiones", label: "sessFrom", sortable: true},
      {key: "diente", label: "diente", sortable: true}
    ];
        this.llenarClinicas();
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerCuentas();
  },
  methods: {
    obtenerCuentas() {
      this.$http.get(this.$api + 'planConvenio/obtener/planesCompletos').then(respuesta => {
            if (respuesta.data.data) {
              this.cuentas = respuesta.data.data;
            }
          }
      )
    },
    llenarClinicas() {
      this.listaClinicas = this.$localStorageService.getClinicas();
    },
    obtenerDatos() {
      let fechaActual = this.$moment(this.filtro.fechaInicio);
      let fechaF = this.$moment(this.filtro.fechaFin);
      let fechaInicial = fechaActual.format("YYYY-MM-DD[T]HH:mm:ssZ");
      let fechaFinal = fechaF.format("YYYY-MM-DD[T]HH:mm:ssZ");
      if(this.filtro.clinica.length === this.listaClinicas.length){
        let lista = []
        this.filtro.clinica.forEach(e=>{
          lista.push(e.idClinica);
        });
        this.filtro.clinica = lista;
      }
        this.loader = true;
        this.datosTabla = [];
        const filtro = {
          "fechaInicio": fechaInicial,
          "fechaFin": fechaFinal,
          "cuentas":this.filtro.idPlan,
           "clinica": this.filtro.clinica
        };

        this.$http
            .post(this.$api + 'reportes/reporteAtenciones', filtro)
            .then(respuesta => {
              if (respuesta.data.data) {

                if (respuesta.data.data !== undefined) {
                  this.datosTabla = respuesta.data.data;
                  this.datosTabla.forEach((value,index) => {
                    this.datosTabla[index]["aceptacion"]=1;
                  });
                }
              }
            }).finally(() => {
          this.loader = false;
          this.paginaActual = 0;
        })
    },
    todos(e) {
      if(e){
        this.filtro.idPlan=this.cuentas.map(c=>c.idPlan);
      }

    },
    fechaMaxima(event){
      this.diasMaximoMes = this.$moment(event).daysInMonth();
      this.filtro.fechaInicio = new Date(event);
      this.filtro.fechaFin = null;
      
    },
   seleccionarTodasClinicas(e) {
       if(e){
      this.filtro.clinica = this.listaClinicas;
       }
    },
  }
}
</script>

<style scoped>

</style>
